// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Lut1i","container__text":"styles_container__text__9S14f","skeleton-animation":"styles_skeleton-animation__KtwLI"};